module.exports = __webpack_public_path__ + "img/UTECHO-2.b3cc710f.jpg";